// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/set-heading-routine.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/set-heading-routine/set-heading-routine.js';

mount([g0]);
